import { connect } from 'react-redux';
import { OPERATIONS } from '../../constants';
import PartValidationStages from '../PartValidation/PartValidationStages';

const mapStateToProps = (state) => {
	return {
		allowedOperations: state.operations.allowedOperations,
	};
};

const PartValidationContainer = ({ 
	allowedOperations, 
	isEmbedded = false, 
	onCompletionOverride = null 
}) => {
	return <PartValidationStages 
		isEmbedded={isEmbedded} 
		onCompletionOverride={onCompletionOverride} 
	/>;
};

export default connect(mapStateToProps)(PartValidationContainer);
